import React from 'react';
import { Calendar, Clock } from 'lucide-react';
import '../styles/DateTimePicker.css';

const DateTimePicker = ({ value, onChange }) => {
  const today = new Date();
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 7); // Màxim 7 dies (límit Open-Meteo)

  const formatDate = (date) => {
    return date.toISOString().split('T')[0];
  };

  const formatDateTime = (dateStr, timeStr) => {
    if (!dateStr || !timeStr) return null;
    return `${dateStr}T${timeStr}`;
  };

  const handleDateChange = (e) => {
    const date = e.target.value;
    const time = document.getElementById('time-input').value || '10:00';
    const dateTime = formatDateTime(date, time);
    onChange(dateTime);
  };

  const handleTimeChange = (e) => {
    const time = e.target.value;
    const date = document.getElementById('date-input').value || formatDate(today);
    const dateTime = formatDateTime(date, time);
    onChange(dateTime);
  };

  const getPreviewText = () => {
    if (!value) return null;
    
    try {
      const date = new Date(value);
      return date.toLocaleString('ca-ES', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return null;
    }
  };

  return (
    <div className="datetime-picker-container">
      <div className="datetime-header">
        <Calendar size={20} className="datetime-header-icon" />
        <h3>Data i hora de la sortida</h3>
      </div>

      <div className="datetime-inputs">
        <div className="input-group">
          <label htmlFor="date-input">
            <Calendar size={16} />
            Data
          </label>
          <input
            type="date"
            id="date-input"
            className="datetime-input"
            min={formatDate(today)}
            max={formatDate(maxDate)}
            onChange={handleDateChange}
          />
        </div>

        <div className="input-group">
          <label htmlFor="time-input">
            <Clock size={16} />
            Hora
          </label>
          <input
            type="time"
            id="time-input"
            className="datetime-input"
            defaultValue="10:00"
            onChange={handleTimeChange}
          />
        </div>
      </div>

      {value && (
        <div className="datetime-preview">
          <strong>Sortida prevista:</strong> {getPreviewText()}
        </div>
      )}

      <p className="datetime-hint">
        Deixa en blanc per obtenir la previsió de les properes 12 hores
      </p>
    </div>
  );
};

export default DateTimePicker;